import { CommandContribution } from '@patsnap/tahiti-core';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { SaveToWorkspaceDialogCommandHandler } from './services/commands/save-to-workspace-dialog.commands';

/**
 * SaveToWorkspace 功能模块
 * 提供保存专利到工作空间的对话框命令
 */
export const saveToWorkspaceModule = (bind: interfaces.Bind) => {
    bind(CommandContribution).to(SaveToWorkspaceDialogCommandHandler);
};
